import { Box } from '@mui/material';
import UPTab from 'components/tab';
import { UPTabSection } from 'components/tab/types';
import { useTranslation } from 'react-i18next';
import { PARITAIR_COMITE__GENERAL, PARITAIR_COMITE__MINIMUM_WAGES } from 'translations/constants';
import { useParams } from 'react-router-dom';
import ParitairComiteGeneral from './ParitairComiteGeneral';
import ParitairComiteMinimumWages from './minimum-wages/ParitairComiteMinimumWages';

const ParitairComiteDetails = (): JSX.Element => {
  const [t] = useTranslation();
  const { paritairComiteId } = useParams();

  const ParitairComiteTabs: UPTabSection[] = [
    { title: t(PARITAIR_COMITE__GENERAL), route: 'general' },
    { title: t(PARITAIR_COMITE__MINIMUM_WAGES), route: 'minimum-wages', isVisible: paritairComiteId !== undefined },
  ];

  return (
    <Box>
      <UPTab sections={ParitairComiteTabs}>
        <ParitairComiteGeneral />
        <ParitairComiteMinimumWages />
      </UPTab>
    </Box>
  );
};

export default ParitairComiteDetails;
